import React, { useState, useEffect } from 'react';
import TemplateService from './TemplateService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import schema from './jsonSchema';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import useTableGenerator from '../../common/functions/useTableGenerator';
import { useNavigate } from 'react-router-dom';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ProgrammingService from '../programming/ProgrammingService';

const TemplateTable = () => {
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [tableGenerated, setTableGenerated] = useState();
  const [showDeleteClasses, setShowDeleteClasses] = useState();
  const [availableClasses, setAvailableClasses] = useState([]);
  const navigate = useNavigate();

  const refreshList = () => {
    TemplateService.retrieveAllTemplatesByAccount()
      .then(data => {
        const updatedData = data.map(item => {
          return {
            ...item,
          };
        });
        console.log('Data', updatedData);
        const actionButtons = [
          {
            icon: 'edit',
            onClick: identifier => {
              navigate('/app/wod/templates/' + identifier);
            },
            className: 'p-0',
            title: 'See details',
            variant: 'action'
          },
          {
            icon: 'trash-alt',
            onClick: identifier => {
              deleteTemplate(identifier);
              //setRefreshList(true);
            },
            className: 'p-0',
            title: 'Delete',
            variant: 'action'
          }
        ];
        setNoDataToShow(updatedData.length === 0);

        setTableGenerated(useTableGenerator(updatedData, jsonSchema, actionButtons));
      })
      .catch(error => setError(error.message));
  };

  const convertTime = time => {
    const date = new Date(time);
    return date.toLocaleDateString();
  };

  const deleteTemplate = identification => {
    TemplateService.deleteTemplate(identification)
      .then(response => {
        console.log(response);
        refreshList();
      })
      .catch(error => console.log(error));
  };

  const jsonSchema = schema;


  useEffect(() => {

    TemplateService.retrieveAllTemplatesByAccount()
      .then(data => {
        const updatedData = data.map(item => {
          return {
            ...item,
          };
        });
        console.log('Data', updatedData);
        const actionButtons = [
          {
            icon: 'edit',
            onClick: identifier => {
              navigate('/app/wod/templates/' + identifier);
            },
            className: 'p-0',
            title: 'See details',
            variant: 'action'
          },
          {
            icon: 'trash-alt',
            onClick: identifier => {
              deleteTemplate(identifier);
              //setRefreshList(true);
            },
            className: 'p-0',
            title: 'Delete',
            variant: 'action'
          }
        ];
        setNoDataToShow(updatedData.length === 0);

        setTableGenerated(useTableGenerator(updatedData, jsonSchema, actionButtons));

      })
      .catch(error => setError(error.message));
    let availableTypes = [];
    ProgrammingService.getTypes().then(types => {
      console.log('Available types:', types);
      types.map(type => {
        availableTypes.push({ label: type, value: type });
      });
      setAvailableClasses(availableTypes);
    });
  }, []);

  const buttonsConf = [
    {
      name: 'Add Template',
      icon: 'plus',
      type: 'button',
      variant: 'info',
      onClick: () => {
        console.log('Edit this data');
        navigate('/app/wod/templates/create-form');
      }
    },
    {
      name: 'Import Templates',
      icon: 'excel',
      type: 'button',
      variant: 'success',
      onClick: () => {
        console.log('Edit this data');
        navigate('/app/wod/templates/import');
      }
    },
    {
      name: 'Delete classes',
      icon: 'delete',
      type: 'button',
      variant: 'danger',
      onClick: () => {
        setShowDeleteClasses(true);
      }
    }
  ];
  const headerGenerated = useHeaderGenerator('Template', ' ', buttonsConf);

  return (
    <>
      {error}
      {headerGenerated}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Template to show.
        </Alert>
      )}
      {tableGenerated}
      <DeleteClassesModal
        show={showDeleteClasses}
        onHide={() => setShowDeleteClasses(false)}
        availableClasses={availableClasses}
      />
    </>
  );
};

const DeleteClassesModal = ({ show, onHide, availableClasses }) => {
  const [type, setType] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleDeleteClick = () => {
    if (!type || !fromDate || !toDate) {
      toast.error('Please fill in all fields', { theme: 'colored' });
      return;
    }
    setShowConfirmation(true);
  };

  const handleConfirmDelete = async () => {
    setLoading(true);
    try {
      await TemplateService.deleteClasses(type, fromDate, toDate);
      toast.success(
        `Classes for ${type} were deleted from ${fromDate} to ${toDate}`,
        { theme: 'colored' }
      );
      setShowConfirmation(false);
      onHide();
      // Reset form
      setType('');
      setFromDate('');
      setToDate('');
    } catch (error) {
      toast.error('Error deleting classes: ' + error.message, {
        theme: 'colored'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowConfirmation(false);
    onHide();
    setType('');
    setFromDate('');
    setToDate('');
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Delete Classes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showConfirmation ? (
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Select
                value={type}
                onChange={e => setType(e.target.value)}
                required
              >
                {availableClasses.map(cls => (
                  <option key={cls.value} value={cls.value}>
                    {cls.label}
                  </option>
                ))}

              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>From Date</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={e => setFromDate(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>To Date</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={e => setToDate(e.target.value)}
                required
              />
            </Form.Group>
          </Form>
        ) : (
          <div className="text-center">
            <h5>Are you sure you want to delete these classes?</h5>
            <p>
              You're about to delete all {type} classes from {fromDate} to{' '}
              {toDate}. This action cannot be undone.
            </p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {!showConfirmation ? (
          <>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteClick}
              disabled={loading}
            >
              Delete Classes
            </Button>
          </>
        ) : (
          <>
            <Button
              variant="secondary"
              onClick={() => setShowConfirmation(false)}
              disabled={loading}
            >
              Go Back
            </Button>
            <Button
              variant="danger"
              onClick={handleConfirmDelete}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Deleting...
                </>
              ) : (
                'Yes, Delete Classes'
              )}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default TemplateTable;
